import './BeforeLoginTemplate.less';
import React, {useState, useEffect} from 'react';
import __ from "../../i18n";


export default function BeforeLoginTemplate({children, contentBoxMaxWidth = 400}) {

    return <div className="before-login-template">
        <div className="container-heading">
            <div className="container-title">{__('Learn Chinese Online')}</div>
            <div className="container-sub-title">{__('Nihao.vn')}</div>
        </div>

        <div className="container-body">
            <div className="container-content-box" style={{maxWidth: contentBoxMaxWidth}}>
                {children}
            </div>
        </div>
    </div>;
}
